import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { AppointmentService } from 'src/app/core/service/appointment.service';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { TranslateService } from '@ngx-translate/core';
import { Dictionary } from 'src/app/core/model/dictionary';
import { sortBy } from 'lodash';
import { SettingService } from 'src/app/core/service/setting.service';

@Component({
  standalone: false,
  selector: 'app-event-cancel-appointment',
  templateUrl: './event-cancel-appointment.component.html',
  styleUrls: ['./event-cancel-appointment.component.scss']
})
export class EventCancelAppointmentComponent implements OnInit
{
  @Output() public save = new EventEmitter<any>();
  @Output() public cancelling = new EventEmitter<any>();

  public appointmentForm: UntypedFormGroup;
  public reasons: Dictionary[];
  public reasonsFiltered: Dictionary[];
  public searchTerm: string;
  public cancelFormActive = false;
  public warningMessage = false;
  public patientLabel = {};

  private statusTypes = [
    {
      id: 'MISSED',
      name: 'APPOINTMENT-STATUS-MISSED',
      text: ''
    },
    {
      id: 'CANCELLED',
      name: 'APPOINTMENT-STATUS-CANCELLED',
      text: ''
    }
  ];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private appointmentService: AppointmentService,
    private dictionaryService: DictionaryService,
    private translate: TranslateService,
    private settingService: SettingService
  )
  {
    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting) =>
      {
        this.patientLabel = { patientLabel: sessionSetting.patientLabel };
      }
    });
  }

  @Input() public set model(appointment: any)
  {
    this.initModel(appointment);
  }

  public ngOnInit(): void
  {
    this.dictionaryService.getCodesByCodeSetName('AppointmentCancellationReason').subscribe({
      next: (data) =>
      {
        this.reasons = data;
        this.reasonsFiltered = data;
      }
    });

    this.translate.get(['APPOINTMENT-STATUS-MISSED', 'APPOINTMENT-STATUS-CANCELLED']).subscribe({
      next: (res) =>
      {
        let index = 0;
        for (const key in res)
        {
          if ({}.hasOwnProperty.call(res, key))
          {
            this.statusTypes[index].text = res[key];
            index++;
          }
        }
      }
    });
  }

  public cancelAppointment(): void
  {
    const cancel = {
      id: this.appointmentForm.controls.id.value,
      cancelReason: this.appointmentForm.controls.cancelReason.value.id,
      comments: this.appointmentForm.controls.comments.value,
      status: this.appointmentForm.controls.status.value.id
    };
    this.appointmentService.cancelAppointment(cancel).subscribe({
      next: () =>
      {
        this.save.emit('');
        this.cancelFormActive = false;
      }
    });
  }

  /**
   * Filter handler for cancel reason dropdown.
   *
   * @param value Reason input.
   */
  public cancelReasonFilter(value: string): void
  {
    this.searchTerm = value;
    this.reasonsFiltered = sortBy(this.reasons.filter(p => p.displayName.toLowerCase().includes(value.toLowerCase())), ['displayName']);
  }

  public closeCancel(): void
  {
    this.cancelFormActive = false;
    this.cancelling.emit('');
  }

  private initModel(appointment: any)
  {
    if (appointment === undefined) { return; }

    this.appointmentService.getAppointmentByEvent(appointment.id).subscribe({
      next: (data) =>
      {
        if (data !== undefined && data !== null)
        {
          this.appointmentForm = this.formBuilder.group({
            id: [appointment.id],
            cancelReason: [data.cancellationReason, Validators.required],
            comments: [data.cancellationComments],
            status: [!(data.status === 'SCHEDULED' || data.status === 'CONFIRMED') ?
              this.statusTypes.find(d => d.id === data.status) :
              this.statusTypes.find(d => d.id === 'CANCELLED'), Validators.required]
          });
          if (data.cancellationReason !== null && data.cancellationReason !== undefined)
          {
            this.warningMessage = true;
          }
          else
          {
            this.warningMessage = false;
          }
        }
        else
        {
          this.appointmentForm = this.formBuilder.group({
            id: [appointment.id],
            cancelReason: [null, Validators.required],
            comments: [null],
            status: [null, Validators.required]
          });
        }
        this.cancelFormActive = true;
      }
    });
  }
}
